export default "__VITE_ASSET__D$YK6Z3h__"